if (typeof BSS_B2B != undefined) {
  setTimeout(async () => {
    await BSS_B2B?.storage?.productStorage.load();
    BSS_B2B.cp?.utils?.init();
    BSS_B2B?.observer?.productSubject?.notifyObserver(
      "ProductMutate",
      "ProductPriceMutate"
    );
  }, 1000);
}

//translate nt start
const ntTranslations = {
  "en": {
    "use_new_address": "Use a new address",
    "checkout_with_nt": "Checkout with Net Terms",
    "close": "Close",
    "continue": "Continue",
    "back": "Back",
    "confirm": "Confirm",
    "contact_information": "Contact information",
    "payment_due_on": "Your payment is due on {{date}}",
    "use_shipping_as_billing": "Use Shipping address as Billing address",
    "required_field": "This field is required",
    "file_type_not_supported": "The following file could not be uploaded: file type is not supported",
    "file_too_large": "The following file could not be uploaded: file size is more than 10MB",
    "order_sent": "Order sent",
    "order_processing_error": "There was an error processing your order.",
    "select_address": "Select address",
    "shipping_address": "Shipping address",
    "billing_address": "Billing address",
    "additional_information": "Additional Information",
    "shipping_method": "Shipping method",
    "subtotal_label": "Subtotal",
    "applied_discount_label": "Order discount",
    "shipping_label": "Shipping",
    "tax_label": "Taxes",
    "total_label": "Total",
    "price_label": "Price",
    "quantity_label": "Quantity",
    "calculated_at_next": "Calculated at next step",
    "cannot_ship_to_address": "Your order cannot be shipped to the selected address. <br>Review your address to ensure it's correct and try again, or select a different address.",
    "ein_invalid": "US EIN is not valid. Please re-enter.",
    "eu_invalid": "EU VAT is not valid. Please re-enter.",
    "abn_invalid": "ABN is not valid. Please re-enter.",
    "gst_invalid": "GST number is not valid. Please re-enter.",
    "uk_invalid": "UK VAT Registration number is not valid. Please re-enter.",
    "pay_later_condition": "Pay later condition",
    "min_amount_error": "To checkout with net terms, you have to choose minimum of {{value}} for the subtotal value.",
    "max_amount_error": "To checkout with net terms, you can only choose maximum of {{value}} for the subtotal value.",
    "min_qty_error": "To checkout with net terms, you have to choose minimum of {{value}} items in total.",
    "max_qty_error": "To checkout with net terms, you can only choose maximum of {{value}} items in total.",
    "none_product": "None of your products are eligible to purchase with net terms.",
    "pls_update_cart": "Please update your cart.",
    "is_not_eligible": "{{quantity}} of your products in cart is not eligible to purchase with net terms:",
    "are_not_eligible": "{{quantity}} of your products in cart are not eligible to purchase with net terms:"
  },
  "fr": {
    "use_new_address": "Utiliser une nouvelle adresse",
    "checkout_with_nt": "Paiement Net 30 jours",
    "close": "Fermer",
    "continue": "Continuer",
    "back": "Retour",
    "confirm": "Confirmer",
    "contact_information": "Coordonnées",
    "payment_due_on": "Votre paiement est dû le {{date}}",
    "use_shipping_as_billing": "Utiliser l’adresse de livraison comme adresse de facturation",
    "required_field": "Ce champ est requis",
    "file_type_not_supported": "Le fichier suivant n’a pas pu être téléchargé : le type de fichier n’est pas supporté",
    "file_too_large": "Le fichier suivant n’a pas pu être téléchargé : la taille du fichier dépasse 10 Mo.",
    "order_sent": "Order sent",
    "order_processing_error": "Une erreur s’est produite lors du traitement de votre commande.",
    "select_address": "Sélectionner une adresse",
    "shipping_address": "Adresse de livraison",
    "billing_address": "Adresse de facturation",
    "additional_information": "Informations supplémentaires",
    "shipping_method": "Mode d'expédition",
    "subtotal_label": "Sous-total",
    "applied_discount_label": "Order discount",
    "shipping_label": "Livraison",
    "tax_label": "Taxes",
    "total_label": "Total",
    "price_label": "Prix",
    "quantity_label": "Quantité",
    "calculated_at_next": "Calculé à l’étape suivante",
    "cannot_ship_to_address": "Votre commande ne peut pas être expédiée à l’adresse sélectionnée. <br>Vérifiez que votre adresse est correcte et réessayez, ou sélectionnez une autre adresse.",
    "ein_invalid": "Le numéro EIN américain n’est pas valide. Veuillez le saisir à nouveau.",
    "eu_invalid": "Le numéro de TVA de l’UE n’est pas valide. Veuillez le saisir à nouveau.",
    "abn_invalid": "Le numéro ABN n’est pas valide. Veuillez le saisir à nouveau.",
    "gst_invalid": "Le numéro de TPS n’est pas valide. Veuillez le saisir à nouveau.",
    "uk_invalid": "Le numéro d’immatriculation à la TVA du Royaume-Uni n’est pas valide. Veuillez le saisir à nouveau.",
    "pay_later_condition": "Condition de paiement à terme",
    "min_amount_error": "Pour passer à la caisse avec des conditions de crédit, vous devez choisir un montant minimum de {{value}} pour le sous-total.",
    "max_amount_error": "Pour passer à la caisse avec des conditions de crédit, vous pouvez uniquement choisir un montant maximum de {{value}} pour le sous-total.",
    "min_qty_error": "Pour passer à la caisse avec des conditions de crédit, vous devez choisir un minimum de {{value}} articles au total.",
    "max_qty_error": "Pour passer à la caisse avec des conditions de crédit, vous pouvez uniquement choisir un maximum de {{value}} articles au total.",
    "none_product": "Aucun de vos produits n’est éligible à l’achat avec des conditions de crédit.",
    "pls_update_cart": "Veuillez mettre à jour votre panier.",
    "is_not_eligible": "{{quantity}} de vos produits dans le panier ne sont pas éligibles à l’achat avec des conditions de crédit :",
    "are_not_eligible": "{{quantity}} de vos produits dans le panier ne sont pas éligibles à l’achat avec des conditions de crédit :"
  }
}

const translation = ntTranslations[Shopify.locale];

if (typeof BSS_B2B != undefined) {
  if (BSS_B2B.nt.ntTranslations) {
    BSS_B2B.nt.ntTranslations = translation;
  }

  //minicart
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  const debouncedHandlePrice = debounce(() => {
      BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
      BSS_B2B.observer.cartSubject.listenCartCheckout()
      BSS_B2B.nt.initFunction()
      document.dispatchEvent(new Event("DOMContentLoaded"))
  }, 200);
    
  function miniCart() {
    const mainProduct = document.querySelector("cart-drawer");
    if (!mainProduct) return;

    const mainObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (
                mutation.target.id === 'cart-drawer__count'
              ) {
                debouncedHandlePrice()
                break;
              }
        }
    })
  
    mainObserver.observe(mainProduct, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
    });
  }
    
  setTimeout(miniCart, 2000);
}


